import { createFileRoute } from '@tanstack/react-router';
import { DivisionsModule } from '@/modules/division';

export const Route = createFileRoute('/(dashboard)/_dashboard/hr/division')({
  component: DivisionsModule,
});
